
import { fetchPermissions  } from "../redux";
import store from '../redux/store';
import { keyBy } from "lodash";
import Permissions from "../utils/PermissionKeys.json";
import { socketDisconnect } from "./SocketServices";
import { checkSession } from "./CheckSessionService";

export const getPermissions = () => {
    let user_info = localStorage.getItem("USER_INFO");
    if(checkSession()){
        let role_id = JSON.parse(user_info).systemRole;
        store.store.dispatch(fetchPermissions(role_id));
    }
}

export const checkIfPermitted = (obj) => {
    let permissionData = {
        enable: false
    };
    const state = store.store.getState();
    
    let permissionArray = state && state.permissionData 
    && state.permissionData.permissionsData && 
    state.permissionData.permissionsData.permissionList 
    ? state.permissionData.permissionsData.permissionList : [];
    
    if(permissionArray.length > 0 && obj.permission_key){
        permissionData = permissionArray.find((item, index)=>(
            item.permission_key === obj.permission_key
        ));
    }
   // console.log("permissionData", permissionData)
    return permissionData && permissionData.enable ? !!permissionData.enable : false;
}

export {Permissions};

